import { tns } from '../models/translationNamespace'
import { Zoning } from '@unreserved-frontend-v2/api/generated/graphql/types'

export const ZONING = [
  { label: `${tns}:zoning.commercial`, value: Zoning.Commercial },
  { label: `${tns}:zoning.industrial`, value: Zoning.Industrial },
  { label: `${tns}:zoning.residential`, value: Zoning.Residential },
]

export const ZONING_LABELS: Record<Zoning, string> = ZONING.reduce(
  (memo, item) => ({ ...memo, [item.value]: item.label }),
  {} as Record<Zoning, string>
)
